export default __webpack_public_path__ + "d6144662c873caba8d2bfc04f78bc60b.svg";